module.exports = __webpack_public_path__ + "static/dubmanji-9843a7fd677f5c29a588b5ea5afb7201.jpg";